export default __webpack_public_path__ + "static/RobotoMono-regular-498042b7fe9cd07b4fd11a0965093e55.woff";